import { type ContextData } from '@common/defaults/ContextData';
import { getThemeConfigByContext, type ThemeConfig, useThemeConfig } from '@common/hooks/useThemeConfig';
import { DesignElementBi3Icon } from '@common/svg/icons/components/DesignElementBi3Icon';
import { DesignElementWh4Icon } from '@common/svg/icons/components/DesignElementWh4Icon';
import { BrandedHeadingVariant, type Props as BrandedHeadingProps } from '@web/atoms/BrandedHeading';

export interface MostViewedThemeConfig {
    brandedHeadingIcon?: BrandedHeadingProps['icon'];
    brandedHeadingVariant?: BrandedHeadingProps['variant'];
}

const THEME_CONFIG: ThemeConfig<MostViewedThemeConfig> = {
    defaults: {},
    byPlatform: {
        bi: {
            brandedHeadingIcon: DesignElementBi3Icon,
            brandedHeadingVariant: BrandedHeadingVariant.ICON,
        },
        wh: {
            brandedHeadingIcon: DesignElementWh4Icon,
            brandedHeadingVariant: BrandedHeadingVariant.ICON,
        },
    },
};

export const getMostViewedThemeConfig = (contextData: ContextData) =>
    getThemeConfigByContext({ config: THEME_CONFIG, contextData });

export const useMostViewedThemeConfig = () => useThemeConfig(THEME_CONFIG);
